import axios from 'axios';
import {
  CREATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION,
} from 'constants/analytics';

import { createActionType } from 'utils/redux';
import { handleErrors } from '../../utils/api';
import { API_CONFIG } from '../../constants/config';
import { analyticsTrack } from '../../utils/analytics';

// object
export const CREATE_SUBSCRIPTION_PENDING = 'CREATE_SUBSCRIPTION_PENDING';
export const CREATE_SUBSCRIPTION_FAIL = 'CREATE_SUBSCRIPTION_FAIL';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_PENDING = 'UPDATE_SUBSCRIPTION_PENDING';
export const UPDATE_SUBSCRIPTION_FAIL = 'UPDATE_SUBSCRIPTION_FAIL';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';
// objects
export const GET_SUBSCRIPTIONS = createActionType('GET_SUBSCRIPTIONS');
export const GET_CHARGEBEE_SUBSCRIPTION = createActionType('GET_CHARGEBEE_SUBSCRIPTION');


export const createSubscription = (
  accountId,
  params = {
    gateway_uid: null,
    subscription_type: null,
    products: null,
  },
) => async (dispatch) => {
  analyticsTrack(CREATE_SUBSCRIPTION, {
    account: accountId,
    ...params,
  }, true);
  dispatch({
    type: CREATE_SUBSCRIPTION_PENDING,
    payload: {},
  });
  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/subscriptions/`,
      params, { withCredentials: true },
    );
    dispatch({
      type: CREATE_SUBSCRIPTION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const updateSubscription = (
  subscriptionId,
  params = {
    status: null,
  },
  seamless = false,
) => async (dispatch) => {
  analyticsTrack(UPDATE_SUBSCRIPTION, {
    subscription: subscriptionId,
    ...params,
  });
  dispatch({
    type: UPDATE_SUBSCRIPTION_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless inline editing
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });
  try {
    const response = await axios.patch(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}subscriptions/${subscriptionId}/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: UPDATE_SUBSCRIPTION_SUCCESS,
      // and this will ensure that data is in sync with backend
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const getSubscriptions = (
  accountId,
  params = {
    status: null,
  },
) => async (dispatch) => {
  try {
    await dispatch({
      type: GET_SUBSCRIPTIONS.name,
      payload: axios.get(
        `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}accounts/${accountId}/subscriptions/`,
        { params, withCredentials: true },
      ),
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const getChargebeeSubscription = (params = {
  subscription_id: null,
}) => async (dispatch) => {
  try {
    await dispatch({
      type: GET_CHARGEBEE_SUBSCRIPTION.name,
      payload: axios.get(
        `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}subscriptions/chargebee/`,
        { params },
      ),
    });
  } catch (error) {
    // don't catch it, we need to handle it in the component
  }
};
